<div class="space-y-4">
  <h1 class="text-2xl font-bold">Consulta de Inventário por SKU</h1>

  @if (error) {
    <app-alert [type]="'danger'">{{ error }}</app-alert>
  }

  <div class="flex flex-col gap-3 md:flex-row md:items-end">
    <div class="flex-1">
      <label class="block text-sm font-medium mb-1">Contas</label>
      <ng-select
        [items]="franchises"
        bindLabel="label"
        bindValue="name"
        [hideSelected]="true"
        [multiple]="true"
        [closeOnSelect]="false"
        [clearable]="true"
        [searchable]="true"
        [(ngModel)]="selectedAccounts"
        [loading]="loadingAccounts"
        class="w-full control-height"
      >
        <ng-template ng-label-tmp let-item="item" let-clear="clear">
          {{ item.name.toUpperCase() }}
          <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <div class="flex flex-col">
            <span class="font-medium">{{ item.name }}</span>
            <span class="text-xs text-neutral-500">{{ item.description }}</span>
          </div>
        </ng-template>
      </ng-select>
    </div>

    <div class="w-40">
      <label class="block text-sm font-medium mb-1">Tipo</label>
      <select [(ngModel)]="searchType" class="w-full control-height px-3 border rounded-md bg-white text-black dark:bg-neutral-900 dark:text-white">
        <option [ngValue]="'SKU'">SkuID</option>
        <option [ngValue]="'REF'">RefID</option>
      </select>
    </div>

    <div class="flex-1">
      <label class="block text-sm font-medium mb-1">Valor</label>
      <input type="text" [(ngModel)]="searchValue" [placeholder]="searchType === 'SKU' ? 'Informe o SKU Id' : 'Informe o Ref ID'"
             class="w-full control-height px-3 border rounded-md bg-white text-black dark:bg-neutral-900 dark:text-white" />
    </div>

    <div class="md:ml-2">
      <app-button color="primary" (buttonClick)="search()">Buscar</app-button>
    </div>
  </div>

  @if (loading) {
    <div class="my-4">
      <app-loading size="large" color="primary" />
    </div>
  }

  @if (!loading && results) {
    <div class="space-y-3">
      <app-accordion [multiple]="true">
        @for (r of results; track r.id) {
          <app-accordion-item [id]="r.id" [label]="`${r.name} (${r.id}) - Total disponível: ${getAvailableTotal(r)}`">
            <div class="p-3 space-y-2">
              @for (item of r.items; track item.warehouseId) {
                <div class="rounded border border-neutral-200 dark:border-neutral-700 p-3 bg-white dark:bg-neutral-900">
                  <div class="flex flex-wrap justify-between gap-2">
                    <div>
                      <div class="text-sm text-neutral-500">Warehouse ({{ item.warehouseId }})</div>
                      <div class="font-medium">{{ item.warehouseName }})</div>
                    </div>
                    <div class="text-right">
                      <div class="text-sm text-neutral-500">Disponível</div>
                      <div
                        class="font-semibold">{{ item.hasUnlimitedQuantity ? '∞' : (item.totalQuantity - item.reservedQuantity) }}
                      </div>
                    </div>
                  </div>
                  <div class="mt-2 grid grid-cols-1 sm:grid-cols-3 gap-3 text-sm">
                    <div>
                      <div class="text-neutral-500">Total</div>
                      <div>{{ item.totalQuantity }}</div>
                    </div>
                    <div>
                      <div class="text-neutral-500">Reservado</div>
                      <div>{{ item.reservedQuantity }}</div>
                    </div>
                    <div>
                      <div class="text-neutral-500">Ilimitado</div>
                      <div>{{ item.hasUnlimitedQuantity ? 'Sim' : 'Não' }}</div>
                    </div>
                  </div>
                  <div class="mt-2 grid grid-cols-1 sm:grid-cols-3 gap-3 text-xs text-neutral-600 dark:text-neutral-300">
                    <div>
                      <div class="text-neutral-500">Tempo Reposição</div>
                      <div>{{ item.timeToRefill || '-' }}</div>
                    </div>
                    <div>
                      <div class="text-neutral-500">Data Abastecimento (UTC)</div>
                      <div>{{ item.dateOfSupplyUtc || '-' }}</div>
                    </div>
                    <div>
                      <div class="text-neutral-500">Lead Time</div>
                      <div>{{ item.leadTime || '-' }}</div>
                    </div>
                  </div>
                </div>
              } @empty {
                <div class="p-3 text-sm text-neutral-600">Nenhum modo de estoque.</div>
              }
            </div>
          </app-accordion-item>
        }
      </app-accordion>
    </div>
  } @else if(!loading) {
    <div class="p-3 text-sm text-neutral-600">Nenhum resultado encontrado.</div>
  }
</div>
